
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.3369 5.52843C12.6119 5.26808 13.0578 5.26808 13.3328 5.52843C13.6078 5.78878 13.6078 6.21089 13.3328 6.47124L9.10745 10.4712C8.84084 10.7236 8.41156 10.7325 8.13363 10.4913L3.90827 6.82461C3.62157 6.57581 3.6022 6.1541 3.86501 5.88269C4.12783 5.61127 4.5733 5.59294 4.86 5.84173L8.58831 9.07708L12.3369 5.52843Z","fill":"currentColor"}})])
          )
        }
      }
    